/**
 * @copyright 2019 @ DigiNet
 * @author tranghoang
 * @create 2019/08/12 10:37
 * @file src/container/app.js
 */

import React, { Component } from 'react';

import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import allReducers from '../../src/utils/allReducers';
import rootSaga from '../../src/utils/rootSaga';
import Index from './index';
import ThemeWrapper from "./themewrapper";
import Config from "../config/index";

/**Using Intl */
import viMessages from '../assets/globalize-devextreme/vi.json';
import enMessages from 'devextreme/localization/messages/en.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme-intl';

/** localize CORE */
import {localizeCoreUI} from '../assets/globalize-core-ui/localize';
import {setGlobal} from "diginet-core-ui/global";

const sagaMiddleware = createSagaMiddleware();
//redux dev-tool
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const reduxDevTools =  process && process.env && process.env.REACT_APP_DEVTOOL ? process.env.REACT_APP_DEVTOOL : 'NO';

var store = null;
if (reduxDevTools === 'YES'){
    store = createStore(allReducers,  composeEnhancers(applyMiddleware(...[sagaMiddleware, thunk])));
} else {
    store = createStore(allReducers, applyMiddleware(...[sagaMiddleware, thunk]));
}

class App extends Component {
    constructor(props) {
        super(props);
        this.initMessages(); /**Using Intl */
        locale(this.getLocale()); /**Using Intl */

        /** Custom Localize CORE UI */
        setGlobal(localizeCoreUI);
    }

    /**Using Intl */
    getLocale() {
        return Config.getLocalStorage('langERP') ? Config.getLocalStorage('langERP') : "vi"
    }

    /**Using Intl */
    initMessages() {
        loadMessages(viMessages);
        loadMessages(enMessages);
    }
    render() {
        const {children} = this.props;
        return (
            <Provider store={store}>
                <ThemeWrapper>
                    <Index>
                        {children}
                    </Index>
                </ThemeWrapper>
            </Provider>
        );
    }
}
sagaMiddleware.run(rootSaga);

export default App;
